import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/**
 *  `DxUserRole` - Роль ползователя.
 **/
let DxUserRole = class DxUserRole {
    constructor(fields) {
        if (fields)
            Object.assign(this, fields);
    }
};
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxUserRole.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUserRole.prototype, "ident", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxUserRole.prototype, "type", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUserRole.prototype, "name", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUserRole.prototype, "description", void 0);
DxUserRole = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], DxUserRole);
export { DxUserRole };
